export const NOTIFY_CHANNELS = ['both', 'textOnly', 'callOnly'] as const;
export type NotifyChannel = (typeof NOTIFY_CHANNELS)[number];

export function notifyChannelLabel(channel: NotifyChannel): string {
  switch (channel) {
    case 'both':
      return 'Text and call';
    case 'textOnly':
      return 'Text only';
    case 'callOnly':
      return 'Call only';
  }
}

export function notifyChannelToFlags(channel: NotifyChannel): { noText: boolean; noCall: boolean } {
  switch (channel) {
    case 'textOnly':
      return { noText: false, noCall: true };
    case 'callOnly':
      return { noText: true, noCall: false };
    default:
      return { noText: false, noCall: false };
  }
}

export function flagsToNotifyChannel(noText?: boolean, noCall?: boolean): NotifyChannel {
  if (noText && !noCall) {
    return 'callOnly';
  }
  if (noCall && !noText) {
    return 'textOnly';
  }
  return 'both';
}
